import { put, take } from 'redux-saga/effects';
import { createCountry } from './country.actions';
import { AppConfig } from '../Entities/Stories/stories.reducer';
import {
  addAppConfig,
  saveStory,
  changeCountry,
  updateHeadlinesByLanguagegroupForAppId,
} from '../StoryEdit/story-edit.actions';

export function* watchForCountryCreate() {
  while (true) {
    const {
      payload: {
        country: { id: appId },
        country,
      },
    } = yield take(createCountry.type);
    const newAppConfig: AppConfig = {
      app_id: appId,
      is_valid: false,
      is_active: false,
    };
    yield put(addAppConfig(newAppConfig));

    yield put(updateHeadlinesByLanguagegroupForAppId({ appId }));

    yield put(saveStory());

    yield put(changeCountry({ country }));
  }
}



// WEBPACK FOOTER //
// ./src/store/Country/country.saga.ts